import { ApexApiError } from 'apex-ui-services'
import { updateAddress as updateAddressApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { ACCOUNT_UPDATE_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'
import { Addresses } from 'types/CommonTypes'

export const updateAddress = (
  accountNumber: string,
  address: Addresses,
  onError: (error: string) => void,
  onSuccess: () => void
) => {
  updateAddressApi(accountNumber, address)
    .then(onSuccess)
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      if (
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
      ) {
        onError(TEMPORARILY_UNAVAILABLE)
      } else if (httpResponseStatus === HttpResponseStatusCodes.Forbidden) {
        onError(ACCOUNT_UPDATE_FAILED)
      } else if (httpResponseStatus === HttpResponseStatusCodes.BadRequest) {
        const {
          response: {
            //@ts-ignore:  Property 'data' does not exist on type 'Response | undefined'.
            data: { details },
          },
        } = error
        details.forEach((err: any) => {
          onError(err.message)
        })
      }
    })
}
